import entertainment from 'fre/assets/img/industry/artsAndEntertainment.svg';
import construction from 'fre/assets/img/industry/constructionServices.svg';
import education from 'fre/assets/img/industry/education.svg';
import foodBeverage from 'fre/assets/img/industry/foodServices.svg';
import healthcare from 'fre/assets/img/industry/healthcare.svg';
import hospitality from 'fre/assets/img/industry/hospitality.svg';
import warehousing from 'fre/assets/img/industry/logistics.svg';
import manufacturing from 'fre/assets/img/industry/manufacturing.svg';
import other from 'fre/assets/img/industry/otherServices.svg';
import retail from 'fre/assets/img/industry/retail.svg';

export const INDUSTRY_KEY = 'fre2024:industry';
export const MOTIVATIONS_KEY = 'fre2024:motivations';

type ImgProps = {
  src: string,
  alt: string,
};

type StepState = {
  key: number,
  label: string
}[]

export const INDUSTRY_MAP: Record<number, ImgProps> = {
  1: {
    src: foodBeverage,
    alt: 'Food & Beverage',
  },
  8: {
    src: hospitality,
    alt: 'Hotels & Hospitality',
  },
  9: {
    src: education,
    alt: 'Education',
  },
  15: {
    src: other,
    alt: 'Other Services',
  },
  16: {
    src: healthcare,
    alt: 'Healthcare / Medical',
  },
  23:  {
    src: entertainment,
    alt: 'Arts & Entertainment & Recreation',
  },
  28: {
    src: retail,
    alt: 'Retail',
  },
  60: {
    src: manufacturing,
    alt: 'Manufacturing',
  },
  92: {
    src: warehousing,
    alt: 'Transportation & Warehousing',
  },
  103: {
    src: construction,
    alt: 'Construction & Trades',
  },
};

export const MOTIVATIONS = [
  {
    key: 'save-time-building-schedule',
    label: 'Save time building the schedule',
  },
  {
    key: 'track-hours-and-availability',
    label: 'Track employee hours and availability easier',
  },
  {
    key: 'better-shift-coverage',
    label: 'Get better shift coverage',
  },
  {
    key: 'easy-team-communication',
    label: 'Communicate with the team more easily',
  },
  {
    key: 'manage-time-off-requests',
    label: 'Manage PTO and time-off requests',
  },
  {
    key: 'manage-labor-costs',
    label: 'Manage labor costs with improved visibility and reporting',
  },
];

//TODO: add icons when we have them ready
export const DIRECT_TO_IMPORT_INDUSTRIES = [
  { value: 1, label: 'Food & Beverage', icon: '' },
  { value: 8, label: 'Hospitality / Entertainment', icon: '' },
  { value: 28, label: 'Retail', icon: '' },
  { value: 16, label: 'Healthcare / Medical', icon: '' },
  { value: 9, label: 'Education', icon: '' },
  { value: 60, label: 'Construction / Manufacturing', icon: '' },
  { value: 15, label: 'Services', icon: '' },
  { value: 45, label: 'Other', icon: '' },
];
